<template>
  <div>
    
    <!-- Header -->
    <div class="header">
      <div class="header-view" :style="'background-image: url('+row.image3+')'">
      </div>
      <div class="container">
        <div class="header-widget">
            <div class="training-widget" :style="'background-image: url('+row.bgColor3_1+')'">
              <div class="bg-title white-color" 
                  v-html="row.title3_1"
                  :style="'color:'+row.color3_1+' !important;white-space:break-spaces'">
              </div>
            </div>
            <div class="accred-widget" :style="'background-image: url('+row.bgColor3_2+')'">
              <div class="bg-title white-color mb-2"
                  v-html="row.title3_2"
                  :style="'color:'+row.color3_2+' !important;white-space:break-spaces'">
              </div>
                <router-link v-if="row.button3_2" :to="row.redirect3_2" class="btn btn-corner">
                  <div>
                    {{ row.button3_2 }} <span class="icon-arrow-right ic"></span>
                  </div>
                </router-link>
            </div>
        </div>
      </div>
    </div>
    <!-- Header -->

  </div>
</template>

<script>
export default {
  name: "Section2",
  props: ['row'],
  components: {},
  data() {
    return {
      pgLoading: true,
    };
  },
  created() {
      //
  },
  methods: {
    //
  },
};
</script>
